import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import SubHeader from '../../components/Subheader/Subheader';
import CustomBreadcrumbs from '../../components/Tools/Breadcumbs';

const HoldingSettlementPage = ({ title, breadcrumbTitle }) => {
    const { financialYears } = useSelector((state) => state.authData);
    const fyList = financialYears.payload.fy_list;
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));

    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
    };

    return (
        <div>
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger} />
            <div className="row" style={{ padding: '10px 16px' }}>
                <div className="col-md-12">
                    <h4 style={{ color: '#28326f', margin: 0 }}>{title}</h4>
                    <CustomBreadcrumbs linksArray={[]} title={breadcrumbTitle || title} />
                </div>
            </div>
            <div className="scheme p-3">
                <p className="text-muted mb-0">Content coming soon.</p>
            </div>
        </div>
    );
};

export default HoldingSettlementPage;
